import { analytics } from "./appAnalytics";
import { AnalyticsEvent } from "./events";
import GoogleTagManagerPlugin from "./plugins/gtm";

const isServer = typeof window === "undefined";

let isGtmActivated = false;

/** Loads Google Tag Manager on the first consent, then resumes tracking on the next ones */
export const grantAnalyticsConsent = () => {
    if (isServer) {
        return;
    }

    analytics.enable();

    if (isGtmActivated) {
        analytics.track(AnalyticsEvent.OptIn, { cookieConsent: true });
        return;
    }

    try {
        const gtmConf = JSON.parse(process.env.GTM_CONFIG ?? "");
        // The plugin announces the consent itself once its data layer exists
        analytics.addPlugin(new GoogleTagManagerPlugin(gtmConf));
        isGtmActivated = true;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn("[SOL:Analytics]: Google tag manager configuration missing", error);
    }
};

/**
 * Announces the refusal, then stops every event: the plugin stays loaded once added, so only
 * disabling the instance keeps the next events from reaching it.
 */
export const revokeAnalyticsConsent = () => {
    if (isServer) {
        return;
    }

    analytics.track(AnalyticsEvent.OptOut, { cookieConsent: false });
    analytics.disable();
};
